import { useUserPreference } from "./useUserPreference";

export const STALE_THRESHOLD_KEY = "deviceStaleThresholdDays";
export const STALE_THRESHOLD_PREF_KEY = "device.staleThresholdDays";
export const STALE_THRESHOLD_OPTIONS = [3, 7, 14, 30] as const;
export type StaleThresholdDays = (typeof STALE_THRESHOLD_OPTIONS)[number];
export const DEFAULT_STALE_THRESHOLD: StaleThresholdDays = 7;

function isValidThreshold(n: unknown): n is StaleThresholdDays {
  return (
    typeof n === "number" &&
    (STALE_THRESHOLD_OPTIONS as readonly number[]).includes(n)
  );
}

/**
 * Per-user stale device threshold, persisted server-side via the shared
 * admin preferences API so it follows the user across browsers. Backed
 * by the generic `useUserPreference` hook with a localStorage mirror
 * for instant first paint.
 */
export function useStaleDeviceThreshold() {
  const { value, setValue, isSaving } = useUserPreference<StaleThresholdDays>({
    key: STALE_THRESHOLD_PREF_KEY,
    defaultValue: DEFAULT_STALE_THRESHOLD,
    validate: isValidThreshold,
    localStorageKey: STALE_THRESHOLD_KEY,
  });

  return { days: value, setDays: setValue, isSaving };
}
